var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F92323"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8335 10.1663C16.8335 9.7061 16.4604 9.33301 16.0002 9.33301C15.5399 9.33301 15.1668 9.7061 15.1668 10.1663V15.1663H10.1668C9.70659 15.1663 9.3335 15.5394 9.3335 15.9997C9.3335 16.4599 9.70659 16.833 10.1668 16.833H15.1668V21.833C15.1668 22.2932 15.5399 22.6663 16.0002 22.6663C16.4604 22.6663 16.8335 22.2932 16.8335 21.833V16.833H21.8335C22.2937 16.833 22.6668 16.4599 22.6668 15.9997C22.6668 15.5394 22.2937 15.1663 21.8335 15.1663H16.8335V10.1663Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.23a6cde7eb241e10239ff2332a1a9ada.svg";
export { ForwardRef as ReactComponent };